/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminUsersZonesSelector
 */
export interface OutputAdminUsersZonesSelector {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUsersZonesSelector
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUsersZonesSelector
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAdminUsersZonesSelector interface.
 */
export function instanceOfOutputAdminUsersZonesSelector(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminUsersZonesSelectorFromJSON(json: any): OutputAdminUsersZonesSelector {
    return OutputAdminUsersZonesSelectorFromJSONTyped(json, false);
}

export function OutputAdminUsersZonesSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminUsersZonesSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAdminUsersZonesSelectorToJSON(value?: OutputAdminUsersZonesSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

